import React, { Component, Fragment } from 'react'
import { Button, Col, Row } from 'antd'
import { compose } from 'recompose'
import Status from '../../../elements/Status'
import withLoadingSection from '../../../elements/HOC/withLoadingSection'
import SubsidiaryModal from './SubsidiaryModal'
import { get, isEmpty } from 'lodash'

class SubsidiaryDetails extends Component {
  render() {
    const { subsidiary, onEdit } = this.props
    return (
      <Fragment>
        <Row>
          <Col span={2} style={{ fontWeight: 'bold' }}>
            Status:
          </Col>
          <Col span={6}>
            {subsidiary.status && <Status value={subsidiary.status} tooltip={false} />}
          </Col>
          <Col span={2} style={{ fontWeight: 'bold' }}>
            Location:
          </Col>
          <Col span={6}>{subsidiary.location}</Col>
          <Col span={2} style={{ fontWeight: 'bold' }}>
            GST/VAT #:
          </Col>
          <Col span={6}>{subsidiary.taxRegistration}</Col>
        </Row>
        <Row>
          <Col span={2} style={{ fontWeight: 'bold' }}>
            Default Bank:
          </Col>
          <Col span={6}>{get(subsidiary,'default.lenderContract')}</Col>
          <Col span={2} style={{ fontWeight: 'bold' }}>
            BaseURL:
          </Col>
          <Col span={6}>{subsidiary.baseURL}</Col>
        </Row>
        <Row
          style={{
            padding: '10px',
            borderBottom: '1px solid rgb(217,217,217)',
          }}>
          <Row span={4} style={{ float: 'right' }}>
            <Button onClick={() => onEdit(subsidiary, 'edit')} type="dashed" icon="user-add">
              Update Tenant
            </Button>
          </Row>
          <SubsidiaryModal {...this.props} />
        </Row>
      </Fragment>
    )
  }
}

export default compose(withLoadingSection)(SubsidiaryDetails)
